import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { showFigurinePreview } from '../../reducers/ui.recoloring';


class FigurineCanvasPreview extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            overlay: 0,
        };
    }

    componentDidMount() {
        const loaded = 0;
        this.overlay = new Image();
        this.overlay.crossOrigin = 'Anonymous';
        this.overlay.onload = () => {
            this.setState(Object.assign({}, this.state, { overlay: 1 }));
        };
        this.overlay.src =
            `https://d1hifgxwzqc0jz.cloudfront.net/schnittmuster/${
                this.props.sewpatId}/${this.props.figurine.src}`;
        this.updatePreview();
    }

    componentDidUpdate(prevProps) {
        if (!this.state.overlay) {
            return;
        }
        this.updatePreview();
    }

    componentWillUnMount() {
        this.overlay.onload = () => {};
    }

    updatePreview() {
        if (!this.state.overlay) {
            return;
        }

        this.canvas = document.createElement('canvas');
        this.canvas.width = this.props.figurine.width;
        this.canvas.height = this.props.figurine.height;
        const ctx = this.canvas.getContext('2d');

        this.pattern = new Image();
        this.pattern.crossOrigin = 'anonymous';
        this.pattern.onload = () => {
            const tempCanvas = document.createElement('canvas');
            const tCtx = tempCanvas.getContext('2d');
            tempCanvas.width = this.props.figurine.width / this.props.col;
            tempCanvas.height =
                this.pattern.height / (
                    this.pattern.width / tempCanvas.width
                );
            tCtx.drawImage(
                this.pattern,
                0,
                0,
                this.pattern.width,
                this.pattern.height,
                0,
                0,
                tempCanvas.width,
                tempCanvas.height,
            );
            ctx.fillStyle = ctx.createPattern(tempCanvas, 'repeat');
            ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
            ctx.drawImage(
                this.overlay,
                0,
                0,
                this.overlay.width,
                this.overlay.height,
                0,
                0,
                this.canvas.width,
                this.canvas.height,
            );
            const imageSrc = this.canvas.toDataURL();
            this.preview.src = imageSrc;
        };
        this.pattern.src = `${this.props.imgSrc}?_`;
    }

    StyledWrapper = styled.figure`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        margin: 0;
        position: absolute;
        top: 5em;
        left: 3em;
        transition: all .75s ease-in-out;
        z-index: 99;

        &.fade {
          opacity: 0.9;
        }

        &.fade.fade-out {
          opacity: 0.01
        }
    `;

    CanvasWrapper = styled.div`
        max-width: ${`${this.props.figurine.width}px`};
        max-height: ${`${this.props.figurine.height}px`};
        width: 60vw;
        height: 85vh;
        
        & .stolo-responsive-img {
          width: 100%;
          height: auto;
        }
    `;

    render() {
        if (this.state.overlay) {
            const classNames = `fade${this.props.showFigurinePreview
                ? ''
                : ' fade-out'}`;
            return (
                <this.StyledWrapper className={classNames}>
                    <this.CanvasWrapper>
                        <img
                            className='stolo-responsive-img'
                            ref={img => this.preview = img}
                            alt='Sewing pattern preview with colored pattern.'
                        />
                    </this.CanvasWrapper>
                </this.StyledWrapper>
            );
        }
        return null;
    }
}


const mapStateToProps = state => (
    { showFigurinePreview: showFigurinePreview(state) }
);

export default connect(mapStateToProps)(FigurineCanvasPreview);



// WEBPACK FOOTER //
// ./src/components/pattern/FigurineCanvasPreview.js